var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_6776_358581)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92556 12.0179C9.97289 11.9615 10.0241 11.8898 10.0817 11.8348C10.5434 11.3382 11.0067 10.842 11.4718 10.3462C12.6993 10.5765 13.8412 10.3052 14.979 9.83423C16.0875 10.3027 17.2433 10.5716 18.4887 10.3462C19.0136 10.9042 19.5255 11.461 20.0631 12.0345C20.0029 12.1407 19.9454 12.2329 19.8942 12.3302C19.7662 12.5862 19.6267 12.8282 19.5102 13.0841V13.0841C19.2697 13.571 19.2239 14.1313 19.3822 14.6508C19.5319 15.1221 19.6492 15.6033 19.7329 16.0908C19.7858 16.4686 19.7978 16.8509 19.7687 17.2313C19.7505 17.6363 19.5373 18.0075 19.1966 18.2271C18.8064 18.5075 18.3947 18.7566 17.9652 18.9721C17.0692 19.3792 16.1412 19.7337 15.2286 20.1139H15.2284C15.0719 20.1804 14.8949 20.1804 14.7383 20.1139C13.649 19.7184 12.5623 19.3126 11.5525 18.7353C11.2965 18.5881 11.0482 18.4217 10.805 18.2528H10.8049C10.4135 17.9842 10.1802 17.5395 10.1815 17.0649C10.1541 16.5842 10.2025 16.1021 10.3249 15.6364C10.4273 15.2691 10.513 14.8965 10.6168 14.5292V14.5292C10.737 14.1323 10.713 13.7057 10.5489 13.3248C10.3607 12.8986 10.1495 12.4851 9.92554 12.0179L9.92556 12.0179ZM16.4664 15.8874C16.9451 15.3985 17.4251 14.9683 17.9064 14.4422L15.8878 14.1312C15.729 13.8074 15.5883 13.5142 15.4436 13.2224C15.299 12.9305 15.1569 12.6515 14.9802 12.3033L14.0664 14.1325L12.0466 14.4474L13.4943 15.8874C13.4098 16.5696 13.2383 17.2019 13.1845 17.8995L14.9854 16.9651L15.6177 17.294C15.8058 17.3914 15.9927 17.4937 16.1848 17.5846C16.3768 17.6755 16.5483 17.8252 16.8043 17.8726C16.6866 17.1815 16.5816 16.5441 16.4664 15.8874Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6776_358581",
    x1: 0,
    y1: 15,
    x2: 30,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationDepartment);
export default __webpack_public_path__ + "static/media/OrganizationDepartment.1727bc78a0f3c7977af0c60acfb02d32.svg";
export { ForwardRef as ReactComponent };